<div class="grid-x grid-margin-x margin line-chart-wrapper">
  <div class="cell small-12 xmedium-7 small-order-2 xmedium-order-1">
    <h4 class="subsection" [innerHTML]="textkeyPrefix + 'headline' | translate"></h4>
    <div>
      <canvas baseChart id="lineChart"></canvas>
    </div>
  </div>
  <div class="cell small-12 xmedium-5 small-order-1 xmedium-order-4">
    <div class="side-help">
      <app-side-helptext [textkey]="textkeyPrefix + 'helptext'" viewPoint="xmedium"></app-side-helptext>
    </div>
  </div>
  <div class="cell small-12 xmedium-7 small-order-4 hint-wrapper">
    <button type="button" aria-controls="hint" [attr.aria-expanded]="showHint" [attr.aria-label]="'arialabel.toggle.info.linechart' | translate" (click)="showHint = !showHint" class="infocallout-button"><i class="icon-info"></i> <span [innerHTML]="textkeyPrefix + 'hint.label' | translate"></span></button>
    @if (showHint) {
      <div class="callout infocallout lighter-gray">
        <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showHint = false"><i class="icon-x"></i></button>
        <p id="hint" [innerHTML]="textkeyPrefix + 'hint' | translate"></p>
        @if (hasAdditionalHeating) {
          <p id="hint" [innerHTML]="textkeyPrefix + 'hint.additionalheating' | translate"></p>
        }
      </div>
    }
  </div>
</div>
